module.exports = __webpack_public_path__ + "static/media/three-star.60463396.png";